import useSWRImmutable from "swr/immutable";
import Auth from "../Auth";
import { useAdminAccess } from "./useAdminAccess";

export default function useNovelImportAccess({ userId, hasAccessToAgenticNovelImport }) {
  // Match resolveAgenticImportAccess on the server. Support access and product
  // previews do not grant the Admin-only override for legacy import.
  const { can } = useAdminAccess();
  const isAdmin = can("admin.tools");
  const shouldFetch = !!userId && !isAdmin && !hasAccessToAgenticNovelImport;
  // Shared by app startup and the modal; keep successful options for this page session.
  const { data, error, isLoading, isValidating, mutate } = useSWRImmutable(
    shouldFetch ? ["/api/import-options", userId] : null,
    ([url]) => Auth.fetchWithIdToken(url, {}),
  );

  return {
    hasAgenticAccess: !isAdmin && (hasAccessToAgenticNovelImport || data?.hasAccessToAgenticNovelImport === true),
    isLoading: shouldFetch && (isLoading || isValidating),
    error: shouldFetch ? error : null,
    retry: mutate,
  };
}
